import { render, staticRenderFns } from "./SalesApplicationPersonalDetailsStep.vue?vue&type=template&id=4671d3ea&"
import script from "./SalesApplicationPersonalDetailsStep.vue?vue&type=script&lang=ts&"
export * from "./SalesApplicationPersonalDetailsStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports